// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jncc","col":"styles_col__3f-Yq","actions":"styles_actions__33W-H","conflict":"styles_conflict__HgtE5"};